/**
 * Google's thumbnail-serving URLs (the `thumbnailLink` Drive gives us) encode the requested
 * size as a trailing "=sNNN" or "=wNNN-hNNN" URL parameter. Swapping that out lets us ask for a
 * much larger (but still server-resized/compressed) preview than Drive's small default
 * thumbnail, without downloading the full original file.
 */
export function buildLargePreviewUrl(thumbnailLink: string | undefined, size: number): string | undefined {
    if (!thumbnailLink) return undefined;
    if (/=s\d+$/.test(thumbnailLink)) {
        return thumbnailLink.replace(/=s\d+$/, `=s${size}`);
    }
    if (/=w\d+-h\d+$/.test(thumbnailLink)) {
        return thumbnailLink.replace(/=w\d+-h\d+$/, `=w${size}-h${size}`);
    }
    return thumbnailLink;
}
